import Logger from '@KrashidBuilt/common/utils/logger';

import { del, get, post, put } from './api';
import { SPEEDLABEL_WEB_API_BASE } from '../constants';

const logger = new Logger(__filename);

export const getAll = async () => {
    logger.extra();
    return await get(`${SPEEDLABEL_WEB_API_BASE}/api/private/checklists`);
};

export const getOne = async ({ checklistId }) => {
    logger.extra({ checklistId });
    return await get(`${SPEEDLABEL_WEB_API_BASE}/api/private/checklists/${checklistId}`);
};

export const createOne = async (data) => {
    logger.extra(data);
    return await post(`${SPEEDLABEL_WEB_API_BASE}/api/private/checklists`, true, data);
};

export const updateOne = async (id, data) => {
    logger.extra(data);
    return await put(`${SPEEDLABEL_WEB_API_BASE}/api/private/checklists/${id}`, true, data);
};

export const removeOne = async ({ checklistId }) => {
    logger.extra({ checklistId });
    return await del(`${SPEEDLABEL_WEB_API_BASE}/api/private/checklists/${checklistId}`);
};

export const removeLogo = async (id) => await del(`${SPEEDLABEL_WEB_API_BASE}/api/private/checklists/${id}/logo`);

export const uploadLogo = async (id, formData) => await post(`${SPEEDLABEL_WEB_API_BASE}/api/private/checklists/${id}/logo`, true, formData);